import { FC } from 'react'
import { PageTitle } from '../../../../_metronic/layout/core'
import { ConfigTab } from '../SellerQueue/components/ConfigTab'
import { useSellerQueuePluginspaceId } from '../SellerQueue/hooks/useSellerQueuePluginspaceId'
import useAuth from '../../../hooks/useAuth'

const SellerQueueConfig: FC = () => {
  const pluginspaceId = useSellerQueuePluginspaceId()
  const { loginInfo } = useAuth()

  const normalizedProfile = String(loginInfo?.profile || '').toLowerCase()
  const isPrivileged =
    normalizedProfile === 'admin' ||
    normalizedProfile === 'owner' ||
    normalizedProfile.includes('manager')

  return (
    <>
      <PageTitle breadcrumbs={[{ title: 'Configuração da Fila', path: '/seller/queue-config', isActive: true }]}> 
        Configuração da Fila de Vendedores
      </PageTitle>

      {!isPrivileged ? (
        <div className='card'>
          <div className='card-body'>
            <div className='alert alert-warning mb-0'>
              Você não possui permissão para acessar esta configuração.
            </div>
          </div>
        </div>
      ) : (
        <div className='card'>
          <div className='card-body'>
            <ConfigTab pluginspaceId={pluginspaceId} />
          </div>
        </div>
      )}
    </>
  )
}

export { SellerQueueConfig }
